module.exports = __webpack_public_path__ + "img/code1.f733de8f.jpg";